import AnalyticsLogger from 'models/AnalyticsLogger';

interface ToggleShowKeyboardShortcutsAction {
  type: 'TOGGLE_SHOW_KEYBOARD_SHORTCUTS';
  show: boolean;
}

/**
 * Redux action to toggle showing keyboard shortcuts.
 */
export function toggleShowKeyboardShortcuts(show: boolean): ToggleShowKeyboardShortcutsAction {
  if (show) {
    AnalyticsLogger.showKeyboardShortcuts();
  }

  return { type: 'TOGGLE_SHOW_KEYBOARD_SHORTCUTS', show };
}

export type UIStateActions = ToggleShowKeyboardShortcutsAction;
